<template>
  <de-layout-content>
    <el-card>
      <div slot="header" class="spcBt">
        <span class="cardTit">编辑成员信息</span>
      </div>
      <el-form
        ref="infoForm"
        :model="infoForm"
        :rules="rules" label-position="top" style="width: 840px"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="alnCt ant-descriptions-title">
              <span style="color: #1890ff">▋</span>基本信息
            </div>
          </el-col>
          <el-col :span="12" v-if="infoForm.type == 9">
            <el-form-item label="成员角色" prop="roleIds">
              <el-select v-model="infoForm.roleIds" multiple filterable clearable placeholder="选择成员角色" style="width: 100%" @change="$forceUpdate()">
                <el-option v-for="item in rolesSelect" :key="item.id" :label="item.remark" :value="item.id" >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="infoForm.name" placeholder="输入姓名" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="照片" prop="headImageUrl">
              <uploadImg :ImgUrl="infoForm.headImageUrl" @imgCallback="(url) => imgCallback(url, 'headImageUrl')"> </uploadImg>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="infoForm.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成员类型" prop="type">
              <el-select v-model="infoForm.type" placeholder="选择成员类型" @change="_allRoles(infoForm.type)">
                <el-option v-for="item in tabList" :key="item.key" :label="item.tab" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="infoForm.type != 9">
            <el-form-item label="成员角色" prop="roleIds">
              <el-select v-model="infoForm.roleIds" multiple filterable clearable placeholder="选择成员角色" style="width: 100%" @change="$forceUpdate()">
                <el-option v-for="item in rolesSelect" :key="item.id" :label="item.remark" :value="item.id" >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号">
              <el-input v-model="infoForm.idCardNo" autocomplete="off" maxlength="18" @change="idInput" placeholder="输入身份证号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model="infoForm.phone" autocomplete="off" maxlength="11" placeholder="输入手机号码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生日" prop="birthday">
              <el-date-picker v-model="infoForm.birthday" type="date" placeholder="输入出生日期" style="width: 100%" :picker-options="pickDateOption">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在部门" prop="organizationId">
              <el-cascader ref="cascaderGroup" style="width: 100%" v-model="infoForm.organizationId" placeholder="选择所在部门" :props="{multiple:true, checkStrictly:true,value:'keyId',label:'name',children:'sonOrganizationVoList'}"
                           :options="departmentOption" @change="handleCascaderChange"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入队时间" prop="workingTime">
              <el-date-picker v-model="infoForm.workingTime" type="date" placeholder="选择入队时间" style="width: 100%" :picker-options="pickDateOption">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年龄">
              <el-input v-model="infoForm.age" placeholder="输入年龄" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="直接上级">
              <el-input v-model="userName" ref="memberInput" placeholder="选择直接上级" @focus="selectMember"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职务">
              <el-select v-model="infoForm.postId" clearable filterable placeholder="选择职务" style="width: 100%">
                <el-option v-for="pos in positionOptions" :key="pos.postId"
                           :label="pos.postName"
                           :value="pos.postId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="infoForm.type == 2">
            <el-col :span="12">
              <el-form-item label="政治面貌">
                <el-select v-model="infoForm.politicalAffiliation" clearable placeholder="选择政治面貌务" style="width: 100%">
                  <el-option v-for="item in politicalAffiliationOptions" :key="item.id"
                             :label="item.name"
                             :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="民族">
                <el-input v-model="infoForm.ethnicGroup" placeholder="输入民族" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="专业">
                <el-input v-model="infoForm.professional" placeholder="输入专业" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="毕业院校">
                <el-input v-model="infoForm.schoolName" placeholder="输入毕业院校" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="籍贯所在地">
                <el-input v-model="infoForm.nativePlace" placeholder="输入籍贯所在地" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="学历">
                <el-input v-model="infoForm.educationalBackground" placeholder="输入学历" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否两库人员" prop="doubleLibrary">
                <el-radio-group v-model="infoForm.doubleLibrary">
                  <el-radio :label="2">是</el-radio>
                  <el-radio :label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </template>

          <el-col :span="12">
            <el-form-item label="状态">
              <el-switch v-model="infoForm.status" :active-value="1" :inactive-value="-1"></el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="备注">
              <el-input v-model="infoForm.remark" type="textarea" :autosize="{ minRows: 5 }" autocomplete="off"
                        placeholder="输入备注" maxlength="100"
                        show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <template v-if="infoForm.type == 2">
            <el-col :span="24">
              <div class="alnCt ant-descriptions-title">
                <span style="color: #1890ff">▋</span>训练信息
              </div>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运动项目" prop="trainingProjectId">
                <el-select v-model="infoForm.trainingProjectId" placeholder="选择运动项目" style="width: 100%">
                  <el-option v-for="item in objTypes" :key="item.id" :label="item.projectName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="集训时间">
                <el-date-picker v-model="infoForm.trainingCampTime" type="date" placeholder="选择集训时间" style="width: 100%" :picker-options="pickDateOption"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="试训时间">
                <el-date-picker v-model="infoForm.practicalTrainingTime" type="date" placeholder="选择试训时间" style="width: 100%" :picker-options="pickDateOption"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="转正时间">
                <el-date-picker v-model="infoForm.employeeTime" type="date" placeholder="选择转正时间" style="width: 100%" :picker-options="pickDateOption"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运动等级">
                <el-select v-model="infoForm.sportLevel" placeholder="选择运动等级" style="width: 100%">
                  <el-option v-for="(item, index) in LevelList" :key="index" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="输送教练">
                <el-input v-model="infoForm.transportCoach" placeholder="输入输送教练" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="输送单位">
                <el-input v-model="infoForm.conveyingUnit" placeholder="输入输送单位" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="房间号">
                <el-input v-model="infoForm.roomNo" placeholder="输入房间号" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="个人简历">
                <el-input v-model="infoForm.establish" type="textarea" :autosize="{ minRows: 5 }" autocomplete="off"
                          placeholder="输入个人简历" maxlength="500"
                          show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运动成绩">
                <el-input v-model="infoForm.sportsPerformance" type="textarea" :autosize="{ minRows: 5 }" autocomplete="off"
                          placeholder="输入运动成绩" maxlength="500"
                          show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="alnCt ant-descriptions-title">
                <span style="color: #1890ff">▋</span>家庭成员信息
              </div>
            </el-col>
            <div style="width: 100%;display: flex;flex-direction: row;gap: 20px" v-for="(item, index) in familieList" :key="index">
              <div style="width: 25%;">
                <el-form-item label="姓名">
                  <el-input v-model="item.name" autocomplete="off" placeholder="输入姓名" maxlength="100"></el-input>
                </el-form-item>
              </div>
              <div style="width: 25%;">
                <el-form-item label="联系方式">
                  <el-input v-model="item.phone" autocomplete="off" maxlength="11" placeholder="输入联系方式"></el-input>
                </el-form-item>
              </div>
              <div style="width: 25%;">
                <el-form-item label="出生年月">
                  <el-date-picker v-model="item.time" type="date" placeholder="选择出生年月" style="width: 100%" :picker-options="pickDateOption"></el-date-picker>
                </el-form-item>
              </div>
              <div style="width: 25%;">
                <el-form-item label="工作单位">
                  <div class="parentsView">
                    <el-input v-model="item.work" autocomplete="off" placeholder="输入工作单位" maxlength="100"></el-input>
                    <i class="el-icon-circle-close delBtn" :class="index == 0?'disable':''" @click="familieList.splice(index, 1)"></i>
                  </div>
                </el-form-item>
              </div>
            </div>
            <el-col :span="24">
              <el-form-item>
                <div style="display: flex;justify-content: center">
                  <el-button icon="el-icon-plus" plain type="primary" @click="addParent">增加一行</el-button>
                </div>
              </el-form-item>
            </el-col>
          </template>
          <el-col>
            <el-form-item>
              <div style="display: flex;justify-content: flex-end">
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click="cancel">取消</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <memberTree
      :keys="checkedKeys"
      :peoples="whoMemberData"
      :dataList="memberList"
      :modalTitle="'选择直接上级'"
      :modalVisible="memberTreeVisible"
      :mpl="false"
      @transmit="getMemberRes"
    ></memberTree>
  </de-layout-content>
</template>

<script>
import axios from "axios";
import moment from "moment";
import * as API_User from "@/api/system/user";
import * as API_Member from "@/api/train/member";
import * as API_System from "@/api/train/system";
import { getMemberTree } from "@/api/member/member";
import SelectGroup from "../components/SelectGroup.vue";
import uploadImg from "@/components/uploadImg/uploadImg.vue";
import {getDepartmentList} from "@/api/team";
import memberTree from "@/views/sportCenter/components/memberTree.vue";
import {getPositionListAll} from "@/api/position";
import { getSportProjectSelectList } from "@/api/train/action";
import {checkPermission} from "@/utils/permission";
let checkPhone = async (rule, value) => {
  if (!value) {
    return Promise.reject("此号码做为登录账号，请务必填写正确");
  }
  // console.log(/^1[3456789]\d{9}$/.test(value));
  if (!/^1[3456789]\d{9}$/.test(value)) {
    return Promise.reject("请输入正确的手机号码格式");
  } else {
    return Promise.resolve();
  }
};

const playerRules = {
  headImageUrl: [{ required: true, message: "请上传照片" }],
  name: [{ required: true, message: "请输入名字" }],
  roleId: [{ required: true, message: "请选择成员角色" }],
  sex: [{ required: true, message: "请选择性别" }],
  height: [{ required: true, message: "请输入体重" }],
  weight: [{ required: true, message: "请输入身高" }],
  phone: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    // { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
  ],
  // idCardNo: [
  //   { required: true, message: "请输入身份证号码", trigger: "blur" },
  //   { pattern: /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确', trigger: 'blur' }
  // ],
  teamId: [{ required: true, message: "请选择所在小组" }],
  employer: [{ required: true, message: "请选择所在机构" }],
  sportsLevel: [{ required: true, message: "请选择运动等级" }],
};
const otherRules = {
  headImageUrl: [{ required: true, message: "请上传照片" }],
  name: [{ required: true, message: "请输入名字" }],
  roleId: [{ required: true, message: "请选择成员角色" }],
  sex: [{ required: true, message: "请选择性别" }],
  phone: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    // { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
  ],
  // idCardNo: [
  //   { required: true, message: "请输入身份证号码", trigger: "blur" },
  //   { pattern: /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确', trigger: 'blur' }
  // ],
  teamId: [{ required: true, message: "请选择所在小组" }],
  employer: [{ required: true, message: "请选择所在机构" }],
  // position: [{ required: true, message: "请选择担任职位" }],
};
const positions = {
  position3: [
    // { code: 1, name: "体能教练" },
    { code: 2, name: "技术教练" },
    { code: 3, name: "战术教练" },
  ],
  position4: [
    { code: 1, name: "科研" },
    { code: 2, name: "队医" },
    { code: 3, name: "营养师" },
    { code: 4, name: "康复师" },
  ],
  position5: [
    { code: 1, name: "领队" },
    { code: 2, name: "副领队" },
    { code: 3, name: "翻译" },
    { code: 4, name: "队管理" },
  ],
};

export default {
  components: {
    memberTree,
    SelectGroup,
    uploadImg,
  },
  provide() {
    return {
      getInfo: () => this.info,
    };
  },
  data() {
    return {
      id: null,
      type: 1,
      eight: 73,
      infoForm: {
        headImageUrl: undefined,
        name: undefined,
        age: undefined,
        sex: undefined,
        phone: undefined,
        employer: undefined,
        position: undefined,
        sportLevel: undefined,
        sportsPerformance: undefined,
      },
      departmentOption: [],
      rolesSelect: [],
      eduList: [],
      teachList: [],
      positionSelectList: [],
      sectionCascaderProps: {
        label: "name",
        value: "id",
        children: "children",
      },
      action: API_System.action,
      imgList: [],
      rules: {
        type: [{ required: true, message: "请选择成员类型", trigger: "blur", }],
        headImageUrl: [ { required: true, message: "请上传照片", trigger: "change", }, ],
        name: [ { required: true, message: "请填写姓名", trigger: "blur", }, ],
        roleIds: [ { required: true, message: "请选择成员角色", trigger: "blur", }, ],
        sex: [ { required: true, message: "请填写性别", trigger: "change", }, ],
        phone: [ { required: true, validator: checkPhone, trigger: "blur", }, ],
        // idCardNo: [
        //   { required: true, message: "请输入身份证号码", trigger: "blur" },
        //   { pattern: /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确', trigger: 'blur' }
        // ],
        organizationId: [{ required: true, message: "请选择所在部门", trigger: "change", }],
        trainingProjectId: [{ required: true, message: "请选运动项目", trigger: "change", }],
        doubleLibrary: [{ required: true, message: "请选择是否为两库人员", trigger: "change", }],
      },
      areaProps: {
        value: "code",
        label: "name",
        children: "areaList",
      },
      sportProps: {
        value: "id",
        label: "name",
        children: "child",
      },

      eduShow: false,
      eduTitle: "添加教育经历",
      eduForm: {
        collegeName: null, // 学校名称
        degree: null, // 学历
        // educationTime: null, // 教育时间
        major: null, // 专业
        startTime: null,
        endTime: null,
      },
      eduRules: {
        collegeName: [{ required: true, message: "请输入学校名称" }],
        degree: [{ required: true, message: "请选择学历" }],
        major: [{ required: true, message: "请输入专业名称" }],
        startTime: [{ required: true, message: "请选择开始年份" }],
        endTime: [{ required: true, message: "请选择结束年份" }],
      },
      tabList: [
        // { key: 1, tab: "超级管理员", permission: 'member:Management'},
        { key: 2, tab: "运动员", permission: 'member:Athlete'},
        { key: 3, tab: "教练员", permission: 'member:Coach'},
        { key: 4, tab: "科研人员", permission: 'member:ScientificResearch'},
        { key: 5, tab: "医疗人员", permission: 'member:MedicalService'},
        { key: 8, tab: "管理人员", permission: 'member:Management'},
        { key: 9, tab: "其他", permission: 'member:Other'},
      ],
      educateData: [
        { id: 1, name: "初中及以下" },
        { id: 2, name: "中专/中技" },
        { id: 3, name: "高中" },
        { id: 4, name: "大专" },
        { id: 5, name: "本科" },
      ],
      objTypes: [],
      teachShow: false,
      teachTitle: "添加教育经历",
      teachForm: {
        companyName: null,
        position: null,
        teachingTime: "",
        times: [],
        teachingContent: null,
      },
      teachRules: {
        companyName: [{ required: true, message: "请输入公司名称" }],
        position: [{ required: true, message: "请输入职位" }],
        teachingContent: [{ required: true, message: "请输入执教内容" }],
        times: [{ required: true, message: "请选择教育时间" }],
      },
      userName: '',
      checkedKeys: [],
      whoMemberData: [],
      memberList: [],
      memberTreeVisible: false,
      positionOptions: [],
      familieList: [],
      politicalAffiliationOptions: [],
      firstLevelId: null,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    // this.rules = this.type == 2 ? playerRules : otherRules;
    if (this.type != 2)
      this.positionSelectList = positions["position" + this.type];
  },
  mounted() {
    this.getCitys();
    this._allRoles(this.type)
    this.getSportItem();
    this.getLevelSelectList();
    this.getPoliticalSelectList();
    this._getDepartmentList()
    // this._getMemberTree()
    // this._getPositionListAll()
    this._getProjectList()
  },
  methods: {
    moment,
    checkPermission,
    setGroupChange(res) {
      // console.log(res);
      this.infoForm.teamId = res.tId;
      this.infoForm.groupId = res.gId;
    },
    _getProjectList(){
      getSportProjectSelectList({}).then(res => {
        this.objTypes = res
      })
    },
    getCitys() {
      let url = `administrativeArea.json`;
      axios.get(url, {}, false, true).then((res) => {
        // console.log(res);
        this.citys = res.data || [];
        // this.getInfo();
        // this.getOperatingRecord();
      });
    },
    _getPositionListAll(organizationId){
      getPositionListAll({organizationId: organizationId}).then(res => {
        if(res.code == 200){
          this.positionOptions = res.data
        }
      })
    },
    _allRoles(type) {
      this.infoForm.roleIds = null
      API_User.allRoles({roleType: type}).then(res => {
        console.log(res);
        if(res.success) {
          this.rolesSelect = res.data
        }
      })
    },
    _getDepartmentList(){
      getDepartmentList({}).then(res => {
        if(res.code == 200){
          this.departmentOption = res.data
        }
      })
    },
    _getMemberTree() {
      let params = { notTypeStr: 2 };
      if (this.checkedKeys.length > 0) {
        params.userIds = this.checkedKeys;
      }
      getMemberTree(params).then(res => {
        if (res.code == 200) {
          let { data } = res
          this.memberList = data
          this.memberTreeVisible = true
          if (this.$refs.memberInput) {
            this.$refs.memberInput.blur();
          }
        }
      });
    },
    // 接口-成员信息
    getInfo() {
      API_Member.memberInfo(this.id).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this._getPositionListAll(res.data.organizationId)
          this.infoForm = res.data;
          this.infoForm.organizationId = []
          res.data.usersGroupList.forEach(item => {
            let list = []
            if(item.organizationId){
              list.push('o'+item.organizationId)
            }
            if(item.teamId){
              list.push('t'+item.teamId)
            }
            if(item.groupId){
              list.push('g'+item.groupId)
            }
            this.infoForm.organizationId.push(list)
          })

          let userIds = []
          let userNameList = []
          res.data.deptUser.forEach(user => {
            userIds.push(user.user_id)
            userNameList.push(user.name)
          })
          this.userName = userNameList.join('，')
          this.checkedKeys = userIds
          this.infoForm.userIds = userIds
          // this.imgList.push(res.data.headImageUrl ? { name: '', url: res.data.headImageUrl } : {})
          if (this.type != 2) {
            this.eduList = res.data.educations.map((item) => {
              console.log(item);
              let times = item.educationTime.split("-").map(Number);
              return {
                ...item,
                degree: item.degree * 1,
                startTime: times[0],
                endTime: times[1],
              };
            });
            this.teachList = res.data.teaches.map((item) => {
              let times = item.teachingTime.split("-").map(Number);
              return {
                ...item,
                times,
                startTime: times[0],
                endTime: times[1],
              };
            });
            this.infoForm.teachValue = this.nameToValue(
              res.data.teachingProject
            );
          } else {
            this.familieList = JSON.parse(JSON.stringify(res.data.userFamilyList))
            // if (res.data.achieves.length) {
            //   let obj = JSON.parse(JSON.stringify(res.data.achieves[0]));
            //   this.infoForm.sportsLevel = obj.sportsLevel ? Number(obj.sportsLevel) : undefined;
            //   // this.infoForm.sportPerformance = obj.sportPerformance
            //   this.$set(
            //     this.infoForm,
            //     "sportPerformance",
            //     obj.sportPerformance
            //   );
            // }
            this.infoForm.trainValue = this.nameToValue(
              res.data.trainingProject
            );
          }
          console.log(this.infoForm);
        }
      });
    },
    // 接口-运动项目
    getSportItem() {
      API_System.getSportItem().then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.sportItemData = this.getTreeData(res.data, "child");
          // console.log(this.sportItemData);
          console.log(this.infoForm);
          this.getInfo();
        }
      });
    },
    getPoliticalSelectList(){
      API_System.getPoliticalSelectList().then(res => {
        if(res.code == 200){
          this.politicalAffiliationOptions = res.data
        }
      })
    },
    // 接口-运动员等级
    getLevelSelectList() {
      API_System.getLevelSelectList().then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.LevelList = res.data;
        }
      });
    },
    idInput(e) {
      // console.log(e);
      let regex = /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/
      if(regex.test(e)) {
        const reg = /^(\d{6})(\d{4})(\d{2})(\d{2})/;
        const match = e.match(reg);
        if(e.length ==18) {
          const birthYear = +e.substring(6, 10);
          const currentYear = new Date().getFullYear();
          this.$set(this.infoForm,'age', currentYear - birthYear )
          this.$set(this.infoForm,'birthday', `${match[2]}.${match[3]}.${match[4]}`)
        }
      }
    },
    getTreeData(data, key) {
      for (let i = 0; i < data.length; i++) {
        if (data[i][key].length < 1) {
          data[i][key] = undefined;
        } else {
          this.getTreeData(data[i][key], key);
        }
      }
      return data;
    },
    nameToValue(str) {
      // console.log(str);
      let valArr = [];
      if (str) {
        let arr = str.split(",");
        // console.log(arr);
        for (let a = 0; a < arr.length; a++) {
          const subArr = arr[a].split("/");
          // console.log(subArr);
          for (let i = 0; i < this.sportItemData.length; i++) {
            const first = this.sportItemData[i];
            if (first.name == subArr[0]) {
              // console.log(first);
              for (let j = 0; j < first.child.length; j++) {
                const second = first.child[j];
                if (second.name == subArr[1]) {
                  // console.log(second);
                  for (let k = 0; k < second.child.length; k++) {
                    const third = second.child[k];
                    if (third.name == subArr[2]) {
                      // console.log(third);
                      valArr.push(third.id);
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        valArr.push("");
      }
      // console.log(this.sportItemData);
      // console.log(valArr);
      return valArr;
    },
    imgCallback(imgUrl, key) {
      this.$nextTick(() => {
        this.$set(this.infoForm, "headImageUrl", imgUrl);
      });
    },
    cancel() {
      this.$router.back()
    },
    onSubmit() {
      console.log(this.infoForm);
      console.log(this.rules)
      this.$refs["infoForm"].validate((valid) => {
        if (valid) {
          console.log("onSubmit");
          this.handleSubmit();
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },
    handleSubmit() {
      console.log(this.infoForm);
      let data = JSON.parse(JSON.stringify(this.infoForm));
      let params = {
        id: data.id,
        type: data.type,
        name: data.name,
        headImageUrl: data.headImageUrl,
        sex: data.sex,
        roleIds: data.roleIds,
        idCardNo: data.idCardNo,
        phone: data.phone,
        birthday: data.birthday,
        organizationId: data.organizationId,
        workingTime: data.workingTime,
        age: data.age,
        postId: data.postId,
        politicalAffiliation: data.politicalAffiliation,
        ethnicGroup: data.ethnicGroup,
        professional: data.professional,
        schoolName: data.schoolName,
        nativePlace: data.nativePlace,
        educationalBackground: data.educationalBackground,
        userIds:data.userIds,
        trainingProjectId: data.trainingProjectId,
        doubleLibrary: data.doubleLibrary,
        trainingCampTime: data.trainingCampTime,
        practicalTrainingTime: data.practicalTrainingTime,
        employeeTime: data.employeeTime,
        sportLevel: data.sportLevel,
        transportCoach: data.transportCoach,
        conveyingUnit: data.conveyingUnit,
        roomNo: data.roomNo,
        establish: data.establish,
        sportsPerformance: data.sportsPerformance,
        status: data.status,
        remark: data.remark,
        familieList: this.familieList,
      };

      let usersGroupList = []
      let organizationId = JSON.parse(JSON.stringify(params)).organizationId;

      let queryForm = {}

      if (params.type == 2){
        // let achieves = data.achieves[0]
        // achieves.sportPerformance = params.sportPerformance || null
        // achieves.sportsLevel = params.sportsLevel || null
        queryForm = {
          ...JSON.parse(JSON.stringify(params)),
          birthday: moment(params.birthday).valueOf(),
          workingTime: moment(params.workingTime).valueOf(),
          trainingCampTime: moment(params.trainingCampTime).valueOf(),
          practicalTrainingTime: moment(params.practicalTrainingTime).valueOf(),
          employeeTime: moment(params.employeeTime).valueOf(),
        }
        // delete queryForm.sportPerformance
        // delete queryForm.sportsLevel
        delete queryForm.organizationId
        queryForm.familieList.forEach(item => {
          item.time = moment(item.time).valueOf()
        })
      }else{
        queryForm = {
          id: params.id,
          type:params.type,
          name:params.name,
          headImageUrl:params.headImageUrl,
          sex:params.sex,
          roleIds:params.roleIds,
          userIds:params.userIds,
          idCardNo:params.idCardNo,
          phone:params.phone,
          birthday: moment(params.birthday).valueOf(),
          workingTime: moment(params.workingTime).valueOf(),
          age:params.age,
          postId:params.postId,
          status:params.status,
          remark:params.remark,
        }
      }
      organizationId.forEach(item => {
        let groupObj = {
          organizationId: null,
          teamId: null,
          groupId: null,
        }
        item.forEach(iitem => {
          if(iitem[0] == 'o'){
            groupObj.organizationId = Number(iitem.substring(1, iitem.length))
          }
          if(iitem[0] == 't'){
            groupObj.teamId = Number(iitem.substring(1, iitem.length))
          }
          if(iitem[0] == 'g'){
            groupObj.groupId = Number(iitem.substring(1, iitem.length))
          }
        })
        usersGroupList.push(groupObj)
      })
      queryForm.usersGroupList = usersGroupList

      console.log(queryForm)

      API_Member.editUser(queryForm).then((res) => {
        console.log(res);
        this.$message.success("修改成功！");
        this.$router.back()
      });

    },
    addParent(){
      this.familieList.push(
        {
          name: null,
          time: null,
          phone: null,
          work: null
        }
      )
    },
    selectMember() {
      this._getMemberTree()
    },

    getMemberRes(res) {
      if (Array.isArray(res)) {
        this.checkedKeys = res.map((i) => {
          return i.id;
        });
        this.infoForm.userIds = this.checkedKeys
        this.userName = res.map((i) => {
          return i.userName;
        }).join('，');
      }
      console.log(this.checkedKeys);
      // this.$set(this.formDtate,'joinUserIds',this.memberKeys)
      this.memberTreeVisible = false;
    },
    handleCascaderChange(val) {
      if (!val || val.length === 0) {
        this.firstLevelId = null;
        return;
      }

      const currentFirstLevelId = val[0][0];

      if (this.firstLevelId === null) {
        this.firstLevelId = currentFirstLevelId;
        
        this._getPositionListAll(currentFirstLevelId.replace('o',''))
      }

      const filtered = val.filter(path => path[0] === this.firstLevelId);

      if (filtered.length !== val.length) {
        this.infoForm.organizationId = filtered;
        this.$message.warning('只能选择同一机构下的部门');
      }
    },
  },
};
</script>
<style lang="less">
@import "/src/styles/common/common.less";
.editCard .tit {
  font-weight: bold;
}
.el-picker-panel__icon-btn.el-date-picker__next-btn.el-icon-d-arrow-right,
.el-picker-panel__icon-btn.el-date-picker__prev-btn.el-icon-d-arrow-left {
  color: #999;
}
</style>
<style scoped lang="less">
.red {
  color: red;
}
.el-cascader-menu__wrap {
  height: 204px;
  background-color: lightblue;
}
.ant-descriptions-title {
  color: #fff;
}
.editCard {
  .tableItem {
    padding: 10px;
    margin-bottom: 2px;
    line-height: 24px;
    background: #21284b;
    h4 {
      margin: 0;
      color: #fff;
    }
  }
  .el-form-item .el-form-item__content {
    // .el-input,
    .el-select,
    .el-cascader {
      width: 100% !important;
    }
  }
}
.el-form-item .el-form-item__content {
  // .el-input,
  .el-select,
  .el-cascader {
    width: 100% !important;
  }
}

.eduForm {
  .flx1 .el-date-editor {
    width: 100% !important;
  }
}
.el-empty {
  padding: 0;
}
.parentsView {
  display: flex;
  align-items: center;
  .delBtn {
    font-size: 20px;
    margin-left: 10px;
    color: #F56C6C;
    cursor: pointer;
  }
  .disable {
    opacity: 0;
    cursor: none;
    pointer-events: none;
  }
}
</style>
